import {default as cx} from "classnames"
import {useState} from "react"

import {OrientationBadge} from "./OrientationBadge"
import {OrientationCompetencyScores} from "./OrientationCompetencyScores"
import {OSRModal} from "../OSRModal"
import {NhsrModal} from "../NhsrModal"
import {scoreBadge} from "../../utilities/general"

export const OrientationWeekDetails = ({week, weekData, orientation, hideTextAnswers}) => {
    const [showDetails, setShowDetails] = useState(true)
    const nhsrReadinessBadge = scoreBadge(weekData?.nhsr_avg?.readiness_for_practice_rating || 0, 10)
    const nhsrSupportBadge = scoreBadge(weekData?.nhsr_avg?.support_score || 0, 4)

    const osrMaxBadge = scoreBadge(weekData?.osr_avg?.percent_of_max_osr_score || 0, 100)
    const osrRatingBadge = scoreBadge(weekData?.osr_avg?.current_readiness_rating || 0, 4)
    const osrReadinessBadge = scoreBadge(weekData?.osr_avg?.readiness_for_practice_rating || 0, 10)

    return (
        <div className="px-6">
            <div className="py-2 px-6 d-flex flex-wrap rounded-top-2 bg-gray-700i align-items-center min-h-45px gap-2">
                <div
                    className="d-flex align-items-center flex-wrap flex-grow-1 cursor-pointer gap-2"
                    onClick={() => setShowDetails(!showDetails)}
                >
                    <span className="me-3">
                        <i
                            className={cx("text-white fas fs-3", showDetails ? "fa-square-minus" : "fa-square-plus")}
                        ></i>
                    </span>
                    <h3 className="text-white fs-4 mb-0 me-4 d-flex align-items-center">
                        Week {week}: {osrMaxBadge.score > 0 ? `${osrMaxBadge.score}%` : ""}
                    </h3>
                    {osrMaxBadge.score > 0 && (
                        <div className={cx("badge px-4 py-3", osrMaxBadge?.background, osrMaxBadge.textColor)}>
                            {osrMaxBadge?.badge}
                        </div>
                    )}
                </div>
                <div className="d-flex justify-content-end gap-2 ms-auto">
                    <div className="d-flex justify-content-end fs-6 align-items-center text-light">
                        <span className="fw-bold me-2">View:</span>
                        {weekData?.nhsrs && <NhsrModal nhsrs={weekData.nhsrs} />}
                        {weekData?.osrs && (
                            <OSRModal
                                osrs={weekData.osrs}
                                orienteeName={orientation?.name ?? null}
                                hideTextAnswers={hideTextAnswers}
                            />
                        )}
                    </div>
                </div>
            </div>
            {showDetails && (
                <div className="p-6 border border-gray-300 rounded-bottom-2">
                    <div className="row gy-4 gx-10">
                        <div className="col-12  col-lg-8 ">
                            <div className="d-flex flex-column ">
                                <div className="d-flex flex-wrap fw-semibold fs-6 mb-2 pe-2">
                                    Week {week} Feedback &amp; Assessement Scores
                                </div>
                                <div className="row">
                                    {osrRatingBadge.score > 0 && (
                                        <OrientationBadge
                                            badge={osrRatingBadge}
                                            label="Preceptorship Score:"
                                            maxScore={4}
                                        />
                                    )}
                                    {nhsrSupportBadge.score > 0 && (
                                        <OrientationBadge
                                            badge={nhsrSupportBadge}
                                            label="Support Score:"
                                            maxScore={4}
                                        />
                                    )}
                                </div>
                                <div className="row">
                                    {osrReadinessBadge.score > 0 ? (
                                        <OrientationBadge
                                            badge={osrReadinessBadge}
                                            label="Preceptor-Assessed Readiness:"
                                            maxScore={10}
                                        />
                                    ) : (
                                        <div className="col-12 col-lg-6">
                                            <div className="d-flex align-items-center flex-column mb-2 mb-lg-4">
                                                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                    <span className="fw-semibold fs-7">
                                                        Preceptor-Assessed Readiness:
                                                    </span>
                                                    <span className="fw-bold fs-7">Missing</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {nhsrReadinessBadge.score > 0 ? (
                                        <OrientationBadge
                                            badge={nhsrReadinessBadge}
                                            label="Self-Assessed Readiness:"
                                            maxScore={10}
                                        />
                                    ) : (
                                        <div className="col-12 col-lg-6">
                                            <div className="d-flex align-items-center flex-column mb-2 mb-lg-4">
                                                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                    <span className="fw-semibold fs-7">Self-Assessed Readiness:</span>
                                                    <span className="fw-bold fs-7">Missing</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {weekData?.osr_avg && <OrientationCompetencyScores osr={weekData.osr_avg} week={week} />}
                    </div>
                </div>
            )}
        </div>
    )
}
